<template>
    <the-form-layout no-footer :init-method="getDesktopConfig">
        <template #default="{ data }">
            <isc-form-item label="Logo">
                <the-upload-logo v-model="data.logo" config-type="desktop" @success="onLogoSuccess" />
            </isc-form-item>

            <isc-form-item label="背景图片">
                <the-desktop-background
                    :backgrounds.sync="data.backgrounds"
                    :remove-method="removeDesktopBackground"
                    :edit-method="editDesktopBackground"
                />
                <the-upload-background
                    v-show="data.backgrounds.length < 4"
                    config-type="desktop"
                    @success="(pic) => onSuccess(data, pic)"
                />
            </isc-form-item>
        </template>
    </the-form-layout>
</template>

<script>
import TheFormLayout from '../components/the-form-layout';
import { getDesktopConfig, removeDesktopBackground, editDesktopBackground } from './service';
import TheUploadLogo from '@/components/desk-header/components/configs/components/the-upload-logo';
import TheDesktopBackground from '@/components/desk-header/components/configs/desktop-config/components/the-desktop-background';
import TheUploadBackground from '@/components/desk-header/components/configs/components/the-upload-background';

export default {
    name: 'LoginConfig',

    components: {
        TheUploadBackground,
        TheDesktopBackground,
        TheUploadLogo,
        TheFormLayout
    },

    data() {
        return {
            getDesktopConfig,
            removeDesktopBackground,
            editDesktopBackground
        };
    },

    methods: {
        /**
         * @param url {string}
         */
        onLogoSuccess(url) {
            this.$store.commit('desk/setBrandLogo', url);
        },

        /**
         * @param form
         * @param pic {DesktopPicture}
         */
        onSuccess(form, pic) {
            form.backgrounds.push(pic);
            this.$store.commit('desk/setBackgroundImage', pic.pictureUrl);
        }
    }
};
</script>

<style lang="scss" scoped></style>
